import React, { useEffect, useState } from "react";
import { Button, Space, Table, Badge, message, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { IconCopy, IconDownloadFile, IconSearch, } from "../../icons";

import { getDocFileSandBox, } from "../../store/sandbox";
import { getSandboxData, getSandboxMyAssetsDrop} from "../../store/sandbox/selectors";


function SandboxList({fetchData, currentPage, setCurrentPage, setSearch, setVerdict, search, verdict, renew, setRenew, fileType, setFileType, serial, setSerial}) {
	const [messageApi, contextHolder] = message.useMessage();
	const dispatch = useDispatch()
	
	const assetsData = useSelector(getSandboxData)
	const [copyText, setCopyText] = useState(null);
	const myAssetsDrop = useSelector(getSandboxMyAssetsDrop)
	const copyBufferTextTable = (text) => {
		navigator.clipboard.writeText(text)
			.then((res) => {

				setCopyText({ text: 'Copy', field: 'table' })
			})
			.catch(err => {
				setCopyText({ text: 'Error', field: 'table' });
			});
	}

	useEffect(() => {
		if (copyText) messageApi.info(copyText.text);
	}, [copyText])

	function renderMultilineTitle(title, subtitle) {
		return <Space size={0} direction="vertical"><span >{title}</span></Space>
	}

	const viewVerdict = (verdict) => {
		let color;
		switch (verdict) {
			case 'Malware': color = 'red'; break;
			case 'Benign': color = 'lime'; break;
			default: color = 'grey';
		}
		return color;
	}
	const changeDate = (date) => {

		if (date) {
			const formatDate = date?.split('T');
			const reverseDate = formatDate[0].split('-').reverse().join('.') + " " + formatDate[1].split('.')[0];
			return reverseDate

		}
		else return null
	}
	const columns = [

		createColumn(renderMultilineTitle('Check DateTime (UTC)', 'Ordered Desc'), "checked_dt", (text) => changeDate(text)),
		createColumn("SN", "firewall_id"),
		createColumn("Platform", "platform_name", (text) => text || 'Нет данных'),
		createColumn("SHA256", "file_hash", (text, row) => <div title={text}>...{text.slice(-35)}<Button size="small" type="text" icon={<IconCopy style={{ color: "#8090B8" }} />}
			onClick={() => {
				copyBufferTextTable(text);
			}}
		/></div>),
		createColumn("File Type", "file_type",),
		createColumn("Verdict", "verdict", (text, row) => <Badge count={text} showZero color={viewVerdict(text)} />),
		createColumn("Report", "file_link", (text, row) =>
			<Button size="small" type="text" icon={<IconDownloadFile style={{ color: "#8090B8" }} />}
				onClick={() => {
					downloadFile(row)
				}}
				title={row['file_hash']}
			>
			</Button >
		),
	]
	const clearFilters = () => {
		setFileType(null)
		setSearch('');
		setVerdict(null);
		setSerial(null);
	}

	const downloadFile = async (file, type) => {
		let stringType = file.file_link.slice(-5);
		let index = stringType.lastIndexOf('.');
		dispatch(getDocFileSandBox({ hash: file.file_hash, name: file.firewall_id, typeFile: stringType.slice(index + 1) }))
	}
	return (
		<Space direction="vertical" size={20} style={{ width: "100%", position: "relative" }}>
			<div style={{width: '100%', display: "flex", justifyContent: "space-between",  position: "relative" }}>
				<Space>
				<Input
					prefix={<IconSearch style={{ color: "#C1C2C9", }} />}
					value={search}
					disabled={assetsData? false: true}
					placeholder="Поиск по hash"
					onChange={(e) => {setCurrentPage(1); setSearch(e.target.value)}}
				/>
				<Select
				style={{width: '175px'}}
					onChange={(e) => {setCurrentPage(1); setSerial(e) }}
					placeholder="Серийник"
					//defaultValue={''}
					value={serial}
					options={
						myAssetsDrop?.map((item)=> {return {value: item.firewall_id, label: item.firewall_id}})
						//{ value: '', label: "Выберите вердикт" },
						// { value: "Malware", label: "Malware" },
						// { value: "Benign", label: "Benign" },
					}
				/>
				<Select
				style={{width: '120px'}}
					onChange={(e) => {setCurrentPage(1); setVerdict(e) }}
					placeholder="Вердикт"
					//defaultValue={''}
					value={verdict}
					options={[
						//{ value: '', label: "Выберите вердикт" },
						{ value: "Malware", label: "Malware" },
						{ value: "Benign", label: "Benign" },
					]}
				/>
				<Select
			style={{width: '150px'}}
				//defaultValue={''}
					onChange={(e) => { setCurrentPage(1);setFileType(e) }}
					placeholder="Тип файла"
					value={fileType}
					options={[
						
						{ value: "pdf", label: "pdf" },
						{ value: "ms-office", label: "ms-office" },
						{ value: "pe", label: "pe" },
						{ value: "jar", label: "jar" },
						{ value: "flash", label: "flash" },
						{ value: "email-link", label: "email-link" },
						{ value: "archive", label: "archive" },
						{ value: "script", label: "script" },
					]}
				/>
				{(verdict || search || fileType || serial) && <Button
					style={{
						backgroundColor: "transparent",
						display: !true ? "none" : "",
					}}
					onClick={() => clearFilters()}
				>
					Сбросить
				</Button>}</Space>
				<Button
				type='primary'
					onClick={() => setRenew(!renew)}
				>
					Обновить
				</Button>
			</div>

			{assetsData &&
				<Table
					columns={columns}
					rowKey={obj => obj.file_hash + obj.firewall_id}
					size="small"
					pagination={{
						current: currentPage,
						showSizeChanger: false,
						position: "bottomRight",
						defaultPageSize: 20,
						total: assetsData?.count,
						onChange: (page) => setCurrentPage(page)
					}}
					style={{ overflowX: "auto" }}
					className="table"
					
					dataSource={assetsData.items}
				/>
			}
		</Space>

	)
}

function createColumn(title, key, render) {
	return { title, key, dataIndex: key, render }
}

export default SandboxList;
